<template>
<div id="ListPessoas" class="container small" >
  <div id="modal-template" v-if="showModal" @close="showModal = false">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <slot name="header">
                Cadastro de Pessoa
              </slot>
            </div>
            <div class="modal-body">
              <slot name="body">
                <AddPessoa class="modal-body-int" :pessoa="pessoa" @list-closeModal="closeModal()"></AddPessoa>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <div id="modal-endereco" v-if="showModalEndereco" @close="showModalEndereco = false">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <slot name="body">
                  <Endereco :endereco="endereco" @list-closeModalEndereco="closeModalEndereco()"></Endereco>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
  <div id="modal-confirm" v-if="showModalConfirm" @close="showModalConfirm = false">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <slot name="body">
                  <Confirm :texto="texto" :elementId="elementId" @confirm-cancel="closeModalConfirm()" @confirm-ok="onDelete()"></Confirm>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
  <div id="modal-confirm" v-if="showModalPe" @close="showModalPe = false">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <slot name="body">
                  <PessoaEquipamento :pessoa="pessoa" @list-closeModalPe="closeModalPe()"></PessoaEquipamento>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
<div class="card">    
  <div class="card-header">
      Lista de Pessoas <router-link class="btn btn-success" :to="{ name: 'AddPessoa' }" >Adicionar</router-link>
      <form class="form-inline float-right">      
        <i class="fas fa-search busca" aria-hidden="true"></i> 
        <input class="form-control float-right" type="text" aria-label="Pesquisar" v-model="tBusca" v-on:keydown="eBusca">
      </form>
      <div class="accordion" id="accordionExample">
        <div class="card">
          <div class="card-header ch-filtros" id="headingOne">
            <h5 class="mb-0">
              <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseFiltro" aria-expanded="true" aria-controls="collapseFiltro">
                Filtros
              </button>
            </h5>
          </div>
          <div class="row collapse" id="collapseFiltro">
            <div class="form-group col-md-4">
              <label v-for="t in tipos" v-bind:key="t.id"  class="container checkbox-inline">
                <input v-on:change="selecionaTipo(t.id)"  type="checkbox"> {{t.descricao}}
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="form-group col-md-4">
              <label v-for="t in cargos" v-bind:key="t.id"  class="container checkbox-inline">
                <input v-on:change="selecionaCargos(t.id)"  type="checkbox"> {{t.descricao}}
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="form-group col-md-4">
              <label v-for="t in unidades" v-bind:key="t.id"  class="container checkbox-inline">
                <input v-on:change="selecionaUnidades(t.id)"  type="checkbox"> {{t.descricao}}
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col">
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>            
            <th>
            </th>
            <th>
              ID Interno
            </th>
            <th>
              UN
            </th>
            <th>
              Dt. Cad.
            </th>
            <th>
              Nome
            </th>
            <th>
              Fantasia
            </th>
            <th>
              CNPJ/CPF
            </th>
            <th>
              Cargo
            </th>
            <th>
              Tipo
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="obj in pessoas" v-bind:key="obj.id">
            <td>
              <a href="#" class="icon">
                <i v-on:click="setShowModalConfirm('Deseja realmente excluir?', obj.id)" class="fa fa-trash"></i>
              </a>
            </td>
            <td>
              <router-link :to="{ name: 'AddPessoa', params: { pessoa_id : obj.id } }" class="icon">
                <i class="fa fa-edit"></i>
              </router-link>
            </td>
            <td>
              <i  v-if="obj.status.idstatus == 1" class="fa fa-check"></i>
              <i v-else class="fa fa-ban"></i>
            </td>
            <td>
              <a href="#" class="icon">
                <i v-on:click="setShowModalEndereco(
                  { 'logradouro' : obj.logradouro, 
                    'numero' : obj.numero, 
                    'bairro' : obj.bairro, 
                    'complemento' : obj.complemento, 
                    'municipio' : obj.cidade.municipio, 
                    'uf' : obj.cidade.uf }
                )" class="fa fa-map-marker-alt"></i>
              </a>
            </td>
            <td>
              <router-link :to="{ name: 'PessoaEquipamento', params: { idpessoa : obj.id } }" >
                <i class="fa fa-laptop"></i>
               </router-link>
            </td>
            <td>
              {{obj.idinterno}}
            </td>
            <td>
              {{obj.unid_neg.descricao}}
            </td>
            <td>
              {{obj.data_cadastro | formatDate }}
            </td>
            <td>
              {{obj.nome_razao}}
            </td>
            <td>
              {{obj.fantasia}}
            </td>
            <td>
              {{obj.cnpj_cpf}}
            </td>
            <td>
              {{obj.cargo.descricao}}
            </td>
            <td>
              {{obj.tipo.descricao}}
            </td>            
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

</template>
<script>

import AddPessoa from './AddPessoa'//
import Endereco from './Endereco'//
import Confirm from '../Confirm'//
import PessoaEquipamento from './PessoaEquipamento'//

const fb = require('../../config/db.js')

export default {
  name: 'ListPessoas',
  components: {
   AddPessoa,
   Endereco,
   Confirm, 
   PessoaEquipamento,
  },
  data() {
    return {
      pessoas: [],
      showModal: false,
      showModalEndereco: false,
      showModalConfirm: false,
      showModalPe: false,
      texto: '',
      elementId: '',
      tBusca: '',
      cargos: [],
      tipos: [],
      unidades: [],
      tiposSelecionados: [],
      cargosSelecionados: [],
      unidadesSelecionados: [],
      newPessoa: {
        'unid_neg' : { 'idunid_neg' : "", 'descricao' : '' }, 
        'status' : {'idstatus' : "", 'descricao': "" }, 
        'idinterno' : "", 
        'data_cadastro' : "", 
        'nome_razao' : "", 
        'fantasia' : "", 
        'cnpj_cpf' : "", 
        'regiao' : { 'idregiao' : "", 'descricao' : '' }, 
        'logradouro' : "", 
        'numero' : "", 
        'bairro' : "", 
        'complemento' : "", 
        'cidade' : { 'idcidade' : "", 'municipio' : '' , 'uf' : ''}, 
        'cargo' : { 'idcargo' : "", 'descricao' : '' },  
        'tipo' : { 'idtipo' : "", 'descricao' : '' }, 
      },
    }
  },
  created() {
    this.getPessoas('');
    this.getTiposPessoas();
  },
  methods: {
    eBusca: function(){
      if (this.tBusca.length >= 3)
        this.getPessoas(this.tBusca)
      else
        this.getPessoas('');
    },
    selecionaTipo(id){
      const i = this.tiposSelecionados.indexOf(id);
      if (i >= 0)
        this.tiposSelecionados.splice(i, 1);
      else
        this.tiposSelecionados.push(id);

      if (this.tBusca.length >= 3)
        this.getPessoas(this.tBusca)
      else
        this.getPessoas('');
    },
    selecionaCargos(id){
      const i = this.cargosSelecionados.indexOf(id);
      if (i >= 0)
        this.cargosSelecionados.splice(i, 1);
      else
        this.cargosSelecionados.push(id);

      if (this.tBusca.length >= 3)
        this.getPessoas(this.tBusca)
      else
        this.getPessoas('');
    },
    selecionaUnidades(id){
      const i = this.unidadesSelecionados.indexOf(id);
      if (i >= 0)
        this.unidadesSelecionados.splice(i, 1);
      else
        this.unidadesSelecionados.push(id);

      if (this.tBusca.length >= 3)
        this.getPessoas(this.tBusca)
      else
        this.getPessoas('');
    },
    getTiposPessoas(){
      fb.CargosFuncoes.get().then(querySnapshot =>{
        const objects = []
        let tp = []
        querySnapshot.forEach((doc)=>{
          tp =  doc.data();
          tp.id = doc.id;
          objects.push(tp);
        });
        this.cargos = objects;
      });
      fb.TiposPessoas.get().then(querySnapshot =>{
        const objects = []
        let tp = []
        querySnapshot.forEach((doc)=>{
          tp =  doc.data();
          tp.id = doc.id;
          objects.push(tp);
        });
        this.tipos = objects;
      });
      fb.UnidadesNegocios.get().then(querySnapshot =>{
        const objects = []
        let tp = []
        querySnapshot.forEach((doc)=>{
          tp =  doc.data();
          tp.id = doc.id;
          objects.push(tp);
        });
        this.unidades = objects;
      });
    },
    setShowModal(){
      this.pessoa = '';
      this.showModal = true;
    },
    setShowModalConfirm(texto, id){
      this.texto = texto;
      this.elementId = id;
      this.showModalConfirm = true;
    },
    closeModalConfirm(){
      this.showModalConfirm = false;
      this.getPessoas();
    },
    setShowModalEndereco(endereco){
      this.endereco = endereco;
      this.showModalEndereco = true;
    },
    setShowModalPe(pessoa){
      this.pessoa = pessoa;
      this.showModalPe = true;
    },
    closeModalPe(){
      this.showModalPe = false;
      this.getPessoas();
    },
    closeModal(){
      this.showModal = false;
      this.getPessoas();
    },
    closeModalEndereco(){
      this.showModalEndereco = false;
    },
    getPessoas(busca){
      if (String(busca).trim() == ''){
        
        fb.Pessoas.where('del', '==', 'n').orderBy('nome_razao').orderBy('fantasia').get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newPessoa =  doc.data();
            this.newPessoa.id = doc.id;
            if ( (this.tiposSelecionados.length <= 0) && (this.unidadesSelecionados.length <= 0) && (this.cargosSelecionados.length <= 0) )            
              objects.push(this.newPessoa);
            else{
              if (this.tiposSelecionados.length > 0)
                if (this.tiposSelecionados.indexOf(this.newPessoa.tipo.idtipo) < 0)
                  return;
              if (this.cargosSelecionados.length > 0)
                if (this.cargosSelecionados.indexOf(this.newPessoa.cargo.idcargo) < 0)
                  return;
              if (this.unidadesSelecionados.length > 0)
                if (this.unidadesSelecionados.indexOf(this.newPessoa.unid_neg.idunid_neg) < 0)
                  return;
              objects.push(this.newPessoa);
            }
          });
          this.pessoas = objects;
        });
      }else{
        fb.Pessoas.where('del', '==', 'n').orderBy('nome_razao').orderBy('fantasia').get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newPessoa =  doc.data();
            this.newPessoa.id = doc.id;
            if ((String(this.newPessoa.nome_razao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.fantasia).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.cnpj_cpf).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.cargo.descricao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.tipo.descricao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.unid_neg.descricao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
             || (String(this.newPessoa.idinterno).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            )
            if ( (this.tiposSelecionados.length <= 0) && (this.unidadesSelecionados.length <= 0) && (this.cargosSelecionados.length <= 0) )            
              objects.push(this.newPessoa);
            else {
              if (this.tiposSelecionados.length > 0)
                if (this.tiposSelecionados.indexOf(this.newPessoa.tipo.idtipo) < 0)
                  return;
              if (this.cargosSelecionados.length > 0)
                if (this.cargosSelecionados.indexOf(this.newPessoa.cargo.idcargo) < 0)
                  return;
              if (this.unidadesSelecionados.length > 0)
                if (this.unidadesSelecionados.indexOf(this.newPessoa.unid_neg.idunid_neg) < 0)
                  return;
              objects.push(this.newPessoa);
            }
          });
          this.pessoas = objects;
        });
      }
    },
    onEdit(obj){
      this.pessoa = obj;
      this.showModal = true;
    },
    onDelete(){
      fb.Pessoas.doc(this.elementId).update({
        'del': 's',
        'usuario_del': fb.auth.currentUser.email,
        'data_del': new Date()
      });
      this.elementId = '';
      this.showModalConfirm = false;
      this.getPessoas();
    }
  }
}
</script>
<style scoped>
  .busca{
    margin-right: 10px;
  }

  .card{
    margin: 10px;
  }
  .row{
    margin: 10px;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 90%;
    max-height: calc(100% - 120px);
    overflow-y: scroll;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-default-button {
    float: right;
  } 

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }


  .ch-filtros {
    padding: 0px;
  }


  .card-header .form-group {
    margin-top: 20px;
  }

  
  .checkbox-inline {
    display: block;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-inline input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .checkbox-inline:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-inline input:checked ~ .checkmark {
    background-color: #2196F3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-inline input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-inline .checkmark:after {
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }

</style>

